import constant from "../../constant";
const resource = constant.api + "items";

const state = {
  products: {},
};

// getters
const getters = {
  getAll: (state) => {
    return state.products;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    const data = await this._vm.$api.fetch(resource);
    commit("setAll", data);
  },

  async getBySection({ commit }, section_reference) {
    const data = await this._vm.$api.fetch(
      `${resource}/items/${section_reference}`
    );
    commit("setAll", data);
  },
};

// mutations
const mutations = {
  setAll(state, data) {
    state.products = data?.data || data || [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
